import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import emblem from "../assets/banner.png";

export default function Intro({ onDone }) {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => {
      setVisible(false);
      onDone?.();
    }, 1650);
    return () => clearTimeout(t);
  }, [onDone]);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className="fixed inset-0 z-[9998] flex items-center justify-center bg-[#04070A]"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 0.7, ease: [0.19, 1, 0.22, 1] } }}
          data-testid="intro-overlay"
        >
          <motion.div
            initial={{ scale: 0.55, opacity: 0, rotate: -14, filter: "blur(6px)" }}
            animate={{ scale: 1, opacity: 1, rotate: 0, filter: "blur(0px)" }}
            transition={{
              scale: { type: "spring", stiffness: 130, damping: 13, mass: 0.8 },
              rotate: { type: "spring", stiffness: 130, damping: 13, mass: 0.8 },
              opacity: { duration: 0.5, ease: "easeOut" },
              filter: { duration: 0.6, ease: "easeOut" },
            }}
          >
            <motion.img
              src={emblem}
              alt="Drift Tackle Co."
              className="h-44 w-44 md:h-56 md:w-56 object-contain mix-blend-screen"
              animate={{ scale: [1, 1.06, 1] }}
              transition={{ delay: 0.55, duration: 0.5, ease: "easeInOut" }}
            />
          </motion.div>
          <motion.div
            className="absolute bottom-16 font-mono-plex text-[10px] tracking-[0.4em] uppercase text-slate-600"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.6, duration: 0.6 }}
          >
            Built in the North. Proven everywhere.
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
